import React from 'react';
import emptyTableImage from 'shared/images/offline-reports/empty-reports-table.svg';
import styles from './empty-table.module.scss';
import {
    REQUEST_TABLE_IN_PROGRESS_TAB_NAME,
    REQUEST_TABLE_MY_REPORTS_TAB_NAME,
    REQUEST_TABLE_SHARED_WITH_ME_TAB_NAME,
    REQUEST_TABLE_ADMIN_VIEW_TAB_NAME,
    TableActiveTab,
} from 'core/entities/offline-reports/offline-reports';

export interface EmptyTableProps {
    activeTab: TableActiveTab;
}

export const textVocabulary = {
    [REQUEST_TABLE_IN_PROGRESS_TAB_NAME]: {
        headlineText: 'No Reports in Progress',
        mainText: 'Go to Placer XTRA Catalog to make a request for your custom report',
    },
    [REQUEST_TABLE_SHARED_WITH_ME_TAB_NAME]: {
        headlineText: 'No Shared Reports',
        mainText: 'Please make sure that someone shared their report with you',
    },
    [REQUEST_TABLE_MY_REPORTS_TAB_NAME]: {
        headlineText: 'No Solved Reports',
        mainText: 'Wait for the report that are in progress to be processed',
    },
    [REQUEST_TABLE_ADMIN_VIEW_TAB_NAME]: {
        headlineText: 'No Account Reports',
        mainText: 'Please make sure that there are some tickets in your account',
    },
};

export const EmptyTable = ({ activeTab }: EmptyTableProps) => {
    const defaultHeadlineText = textVocabulary[activeTab].headlineText;
    const defaultMainText = textVocabulary[activeTab].mainText;

    return (
        <div className={styles.emptyTable}>
            <img src={emptyTableImage} alt="No data available" />
            <div className={styles.text}>
                <h3>{defaultHeadlineText}</h3>
                <p>{defaultMainText}</p>
            </div>
        </div>
    );
};

export default EmptyTable;
